var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#FF3A21"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19027 7.68461V8.71672H11.117V7.68461H7.19027ZM7.19027 9.28555V10.3663H11.117V9.28555H7.19027ZM11.8345 3.1001V4.22233H13.1694L11.7474 5.64473C11.0028 5.05844 10.0832 4.73883 9.13546 4.73701C8.01216 4.73702 6.93487 5.18329 6.14057 5.97763C5.34628 6.77197 4.90004 7.84932 4.90002 8.97269C4.90126 9.99964 5.27551 10.9912 5.95316 11.7628C6.6308 12.5344 7.56567 13.0335 8.5838 13.1673V14.4101H7.24886V15.6581H8.5838V16.8773H9.82212V15.6581H11.1475V14.4101H9.82212V13.1474C10.8123 12.9847 11.7125 12.4757 12.3624 11.7112C13.0123 10.9466 13.3697 9.97617 13.3709 8.97269C13.369 8.10075 13.0981 7.25064 12.5952 6.5384L14.0017 5.13176V6.36056H15.1527V3.1001H11.8345ZM9.13546 5.89282C9.95223 5.89286 10.7355 6.21736 11.3131 6.79494C11.8906 7.37252 12.2151 8.15587 12.2152 8.97269C12.2152 9.78957 11.8908 10.573 11.3132 11.1507C10.7357 11.7283 9.95229 12.0529 9.13546 12.0529C8.73098 12.0529 8.33045 11.9733 7.95675 11.8185C7.58305 11.6637 7.24351 11.4368 6.9575 11.1508C6.67149 10.8648 6.44461 10.5252 6.28984 10.1515C6.13506 9.77775 6.0554 9.3772 6.05542 8.97269C6.05547 8.15581 6.38 7.37241 6.95762 6.79482C7.53524 6.21723 8.31863 5.89277 9.13546 5.89282V5.89282Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.91a6cb61a835997f69c8491fe51d8d22.svg";
export { ForwardRef as ReactComponent };